module.exports = __webpack_public_path__ + "img/empty_cart.9d005ebc.png";